// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__2D2zM","resultsWrapper":"styles_resultsWrapper__1uUMA","matchList":"styles_matchList__151kh"};